mutation unarchiveTopic($id: ID!) {
  topic: unarchiveTopic(id: $id) {
    id
    name
    description
    status
    isSystemGenerated
    isUserEditable
    landingpage {
      id
      slug
    }
  }
}
